<ngx-spinner
  [size]="'medium'"
  [type]="'ball-scale-multiple'"
  [fullScreen]="true"
/>
